if ( ! window.String.prototype.endsWith ) {
    window.String.prototype.endsWith = function( search, thisLen ) {
        if ( thisLen === undefined || thisLen > this.length ) {
            thisLen = this.length;
        }
        return this.substring( thisLen - search.length, thisLen ) === search;
    };
}
